export default __webpack_public_path__ + "static/media/ielts-9-thumb.7d5d0c82.jpg";